module.exports = __webpack_public_path__ + "img/maps.b87bf731.svg";